import React from 'react';
import { Container, Typography, Box, Paper, Grid, IconButton, Link } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import './Contact.scss';

const Contact = () => {
  const contactInfo = [
    {
      icon: <EmailIcon />,
      label: 'Email',
      value: 'venkat.sujit.adabala@gmail.com',
      link: 'mailto:venkat.sujit.adabala@gmail.com'
    },
    {
      icon: <PhoneIcon />,
      label: 'Phone',
      value: '929-606-0802',
      link: 'tel:+19296060802'
    },
    {
      icon: <LocationOnIcon />,
      label: 'Location',
      value: 'Charlotte, NC',
      link: null
    }
  ];

  const socialLinks = [
    {
      icon: <LinkedInIcon />,
      label: 'LinkedIn',
      link: 'https://linkedin.com/in/avsujit'
    },
    {
      icon: <GitHubIcon />,
      label: 'GitHub',
      link: 'https://github.com/avsujit'
    }
  ];

  return (
    <section id="contact" className="contact-section">
      <Container maxWidth="lg">
        <Typography variant="h2" className="section-title" gutterBottom>
          Get In Touch
        </Typography>
        <Box className="section-divider" />
        <Paper elevation={3} className="contact-content">
          <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
              <Typography variant="h5" className="contact-subtitle" gutterBottom>
                Let's Connect
              </Typography>
              <Typography variant="body1" className="contact-description">
                I'm always open to discussing new opportunities, interesting projects, or just having a conversation 
                about technology and software development. Feel free to reach out!
              </Typography>
              <Box className="contact-info-grid">
                {contactInfo.map((info, index) => (
                  <Box key={index} className="contact-info-item">
                    <Box className="contact-icon-wrapper">
                      {info.icon}
                    </Box>
                    <Box className="contact-details">
                      <Typography variant="body2" className="contact-label">
                        {info.label}
                      </Typography>
                      {info.link ? (
                        <Link href={info.link} className="contact-value" underline="hover">
                          {info.value}
                        </Link>
                      ) : (
                        <Typography variant="body1" className="contact-value">
                          {info.value}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box className="social-section">
                <Typography variant="h6" className="social-title" gutterBottom>
                  Connect on Social Media
                </Typography>
                <Box className="social-buttons">
                  {socialLinks.map((social, index) => (
                    <IconButton
                      key={index}
                      href={social.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-button"
                      aria-label={social.label}
                    >
                      {social.icon}
                    </IconButton>
                  ))}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>
        <Box className="footer">
          <Typography variant="body2" className="footer-text">
            © {new Date().getFullYear()} Venkat Sujit Adabala. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </section>
  );
};

export default Contact;

